import { DocumentType, Gender } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { AddressSchema } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/schemas/AddressSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredEnum, requiredFutureDate, requiredPastDate, requiredString } from '@/utils/zodUtils';
import { validateDocumentNumber } from '@/utils/zodValidation/validateDocumentNumber';

export const DocumentIdFormObjectSchema = (t: GetTextIdTranslationType, showBirthDateField: boolean) =>
  z.object({
    firstName: requiredString(t),
    lastName: requiredString(t),
    documentType: requiredEnum(DocumentType, t),
    documentNumber: z.string().optional().nullable(),
    gender: requiredEnum(Gender, t),
    documentExpeditor: requiredString(t),
    nationality: requiredString(t),
    expiration: requiredFutureDate(t),
    ...(showBirthDateField
      ? {
          birthDate: requiredPastDate(t).nullable(),
        }
      : {}),
    birthPlace: requiredString(t),
    documentAddress: AddressSchema(t),
  });

export const DocumentIdFormSchema = (t: GetTextIdTranslationType, showBirthDateField: boolean) =>
  DocumentIdFormObjectSchema(t, showBirthDateField).refine(
    (data) => validateDocumentNumber(data.documentNumber, data.documentType),
    {
      message: t('INVALID_DOCUMENT_NUMBER'),
      path: ['documentNumber'],
    },
  );

export type DocumentIdFormType = z.infer<ReturnType<typeof DocumentIdFormSchema>>;
